import React, { ReactNode, useEffect, useState } from "react";
import { Button } from "@wearewqa/wqa-design-system";
import { DownloadItemType } from "../../types";
import { getEnvironmentsByAppId } from "../../resources/apps";
import { ItemRow } from "../../components/ItemRow";
import { useAuth } from "../../hooks/auth.provider";
import { CreateEnvironmentModal } from "../../modals/CreateEnvironmentModal";
import { sort } from "../../utilities";
import { AreYouSureModal } from "../../modals/AreYouSureModel";
import { deleteEnvironment } from "../../resources/environments";

type AppPageEnvironmentListType = {
  appId: string | undefined;
  storeId: string | number;
};

export const AppPageListEnvironment = ({
  appId,
  storeId,
}: AppPageEnvironmentListType) => {
  const [showForm, setShowForm] = useState<boolean>(false);
  const [environmentData, setEnvironmentData] = useState<
    DownloadItemType[] | null
  >(null);
  const { currentUser, isAuthenticated } = useAuth();

  // confirmation Model - TODO: find a better way.
  const [confirmationModel, setConfirmationModel] = useState<ReactNode | null>(
    null
  );

  async function handleDeleteEnvironment(envId: string) {
    try {
      if (!currentUser) {
        return;
      }
      const idToken = await currentUser.getIdToken();
      await deleteEnvironment(envId, idToken);
      window.location.reload();
    } catch (error) {
      console.error(
        "AppPageListEnvironments - handleDeleteEnvironment: ",
        error
      );
    }
  }

  useEffect(() => {
    async function getData() {
      try {
        if (typeof appId !== "string") {
          console.error('Error: URL parameter "appId" is not a string.');
          return;
        }

        const environments = await getEnvironmentsByAppId(appId, {
          store_id: storeId,
        });

        const sortedArray = sort<DownloadItemType>(
          environments.body,
          "created_at",
          "decending"
        );

        setEnvironmentData(sortedArray);
      } catch (error) {
        console.error("getAppData: ", error);
      }
    }

    void getData();
  }, [appId, storeId]);

  return (
    <div className="app-page__app-list">
      <>
        <div>
          {environmentData !== null && environmentData.length ? (
            <>
              <h2 className="app-page__sub-header">Environment Versions</h2>
              <p>
                Download or Install specific environment builds here. Please
                note these build should be used as reference only. Please use
                the latest build for QA & Testing purposes.
              </p>
            </>
          ) : (
            <></>
          )}
          {isAuthenticated && appId && (
            <>
              <Button
                label="Upload a new Environment"
                onClick={() => setShowForm(true)}
              />
              <CreateEnvironmentModal
                isOpen={showForm}
                onClose={() => setShowForm(false)}
                appId={appId}
              />
            </>
          )}
        </div>
        {environmentData !== null && environmentData.length ? (
          <div className="app-page__list">
            {environmentData.map((current, index) => (
              <ItemRow
                data={current}
                key={index}
                onDelete={() => {
                  setConfirmationModel(
                    <AreYouSureModal
                      isOpen={true}
                      message={`You are about to DELETE environment: "${current.display_name || current.version_number}".`}
                      onAccept={() =>
                        void handleDeleteEnvironment(String(current.id))
                      }
                      onClose={() => setConfirmationModel(null)}
                    />
                  );
                }}
              />
            ))}
          </div>
        ) : (
          <></>
        )}
        {confirmationModel}
      </>
    </div>
  );
};
